import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "columns is-mobile is-flex is-justify-content-center has-background-white-bis" }
const _hoisted_2 = { class: "column is-11-mobile is-11-tablet is-10-desktop" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_heading = _resolveComponent("heading")!
  const _component_my_repos = _resolveComponent("my-repos")!
  const _component_contributions = _resolveComponent("contributions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_heading, {
        name: _ctx.githubData.data.viewer.name,
        avatarUrl: _ctx.githubData.data.viewer.avatarUrl,
        summary: _ctx.githubData.data.viewer.bio,
        stackoverflowRep: _ctx.stackoverflowData.items[0].owner.reputation
      }, null, 8, ["name", "avatarUrl", "summary", "stackoverflowRep"]),
      _createVNode(_component_my_repos, {
        repos: _ctx.githubData.data.viewer.repositories.nodes
      }, null, 8, ["repos"]),
      _createVNode(_component_contributions, {
        pullRequests: _ctx.githubData.data.viewer.pullRequests.nodes
      }, null, 8, ["pullRequests"])
    ])
  ]))
}